import { Loading } from 'components/loading/Loading';
import SingleAddressTile from 'components/SingleAddressTile';
import CustomLink from 'components/TableLink';
import React, { useEffect, useState } from 'react';
import { fetchUserAddresses } from 'services';
import { showError } from 'utils';
import styles from './index.module.scss';

const ChangeAddressModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [addressesLoading, setAddressesLoading] = useState<boolean>(true);
  const [addresses, setAddresses] = useState<Record<string, any>[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<Record<string, any>>({});
  const {
    userId,
    toggleModal,
    title,
    onAddressChange,
  } = props;

  const fetchUserSavedAddresses = async () => {
    try {
      const response = await fetchUserAddresses(userId);
      setAddresses(response);
    } catch (e) {
      showError(e);
    } finally {
      setAddressesLoading(false);
    }
  };

  useEffect(() => {
    fetchUserSavedAddresses();
  }, []);

  const updateUserSubscriptionAddress = async () => {
    setLoading(true);
    await onAddressChange(selectedAddress);
    setLoading(false);
  };
  
  const getSavedAddresses = () => {
    if (addresses.length > 0) {
      return addresses.map(address => (
        <SingleAddressTile
          key={address.objectId}
          loading={loading}
          contactName={address.contactName}
          contactPhone={address.contactPhone}
          addressDetails={address}
          setAddress={setSelectedAddress}
          deleteAddressFn={() => {}}
          toggleAddressModal={() => {}}
          setAddressToEdit={() => {}}
          setAddressEditMode={() => {}}
          showAddressActions={false}
          showInvalidAddresses={false}
        />
      ));
    } else {
      return (
        <div className={styles['empty-address-message-container']}>
          <div className={styles['empty-address-message-line1']}>No Addresses found for User</div>
          <div className={styles['empty-address-message-line2']}>Please add at least one address.</div>
          <CustomLink text="Go to user" linkTo={`/users/${userId}`}  />
        </div>
      );
    }
  };
  
  return (
    <form onSubmit={e => e.preventDefault()} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Address</div>
            <div className={styles['modal-title']}>{title}</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          {addressesLoading ? (
            <Loading type={'mini'} />
          ): getSavedAddresses()}
        </div>
        <div className={styles['modal-footer']}>
          <button
            type={'button'}
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'button'}
            className={styles['submit-button']}
            disabled={loading || !Object.keys(selectedAddress).length}
            onClick={updateUserSubscriptionAddress}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default ChangeAddressModal;